export default "__VITE_ASSET__74dda100__"